export const LESYM = Symbol.for("__le__");
export const LE_PACK_SYM = Symbol.for("__le__pack__");